/* ==========================================================================
   VOVIA Swatches — vervangt Swatch King (PDP + productkaarten)
   - PDP: server-side gerenderd (snippets/vovia-swatches.liquid); dit script
     regelt alleen hover-naam, directe klik-feedback en bfcache-reset.
   - Kaarten: vult .vsw-card placeholders met data uit /?view=vovia-swatches
     (templates/index.vovia-swatches.liquid), met hover-foto-preview.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__voviaSwatches) return;
  window.__voviaSwatches = true;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ------------------------------------------------------------------ */
  /* PDP                                                                 */
  /* ------------------------------------------------------------------ */

  function setRowValue(row, text) {
    if (!row) return;
    var valueEl = row.querySelector('[data-vsw-value]');
    var sepEl = row.querySelector('.vsw__sep');
    if (valueEl) valueEl.textContent = text || '';
    if (sepEl) sepEl.hidden = !text;
  }

  function resetRow(row) {
    setRowValue(row, row.getAttribute('data-vsw-default') || '');
  }

  // Hover / focus: naam van de swatch tonen in de kop van die rij
  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var a = e.target.closest && e.target.closest('.vsw__swatch');
    if (!a) return;
    setRowValue(a.closest('[data-vsw-row]'), a.getAttribute('data-vsw-name'));
  });

  document.addEventListener('mouseout', function (e) {
    if (!canHover) return;
    var row = e.target.closest && e.target.closest('[data-vsw-row]');
    if (!row) return;
    if (e.relatedTarget && row.contains(e.relatedTarget) && e.relatedTarget.closest('.vsw__swatch')) return;
    resetRow(row);
  });

  document.addEventListener('focusin', function (e) {
    var a = e.target.closest && e.target.closest('.vsw__swatch');
    if (a) setRowValue(a.closest('[data-vsw-row]'), a.getAttribute('data-vsw-name'));
  });

  document.addEventListener('focusout', function (e) {
    var row = e.target.closest && e.target.closest('[data-vsw-row]');
    if (row && !(e.relatedTarget && row.contains(e.relatedTarget))) resetRow(row);
  });

  // Klik: ring en naam direct verplaatsen, daarna normale navigatie (pagina is al geprefetcht)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.vsw__swatch');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    if (a.classList.contains('is-active')) {
      e.preventDefault();
      return;
    }

    var root = a.closest('[data-vsw]');
    if (!root) return;

    if (!root.__vswInitial) {
      root.__vswInitial = Array.prototype.map.call(root.querySelectorAll('[data-vsw-row]'), function (row) {
        return { row: row, def: row.getAttribute('data-vsw-default') || '' };
      });
      root.__vswInitialActive = Array.prototype.slice.call(root.querySelectorAll('.vsw__swatch.is-active'));
    }

    root.querySelectorAll('.vsw__swatch.is-active').forEach(function (x) { x.classList.remove('is-active'); });
    a.classList.add('is-active', 'is-pending');
    root.classList.add('is-navigating');

    var name = a.getAttribute('data-vsw-name') || '';
    root.querySelectorAll('[data-vsw-row]').forEach(function (row) {
      var own = row.contains(a);
      row.setAttribute('data-vsw-default', own ? name : '');
      resetRow(row);
    });
  });

  // Terug-knop (bfcache): oorspronkelijke staat herstellen
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-vsw]').forEach(function (root) {
      root.classList.remove('is-navigating');
      root.querySelectorAll('.vsw__swatch').forEach(function (x) { x.classList.remove('is-active', 'is-pending'); });
      (root.__vswInitialActive || []).forEach(function (x) { x.classList.add('is-active'); });
      (root.__vswInitial || []).forEach(function (s) {
        s.row.setAttribute('data-vsw-default', s.def);
        resetRow(s.row);
      });
    });
  });

  /* ------------------------------------------------------------------ */
  /* Productkaarten                                                      */
  /* ------------------------------------------------------------------ */

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DATA_URL = root + '?view=vovia-swatches';
  var CACHE_KEY = 'vsw:data:' + root;
  var CACHE_TTL = 10 * 60 * 1000;
  var dataPromise = null;
  var index = null;

  function readCache() {
    try {
      var c = JSON.parse(window.sessionStorage.getItem(CACHE_KEY));
      if (c && c.d && Date.now() - c.t < CACHE_TTL) return c.d;
    } catch (err) {}
    return null;
  }

  function writeCache(d) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (err) {}
  }

  function loadData() {
    if (dataPromise) return dataPromise;
    var cached = readCache();
    if (cached) {
      dataPromise = Promise.resolve(cached);
      return dataPromise;
    }
    dataPromise = fetch(DATA_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.g) writeCache(d);
        return d;
      })
      .catch(function () { return null; });
    return dataPromise;
  }

  // handle -> lijst swatches van zijn groep (hoofdrij-lidmaatschap gaat voor extra rij)
  function buildIndex(d) {
    var map = {};
    if (!d || !d.g) return map;
    d.g.forEach(function (g) {
      var items = (g.s || []).concat(g.x || []);
      (g.s || []).forEach(function (it) { if (!map[it[0]]) map[it[0]] = items; });
    });
    d.g.forEach(function (g) {
      var items = (g.s || []).concat(g.x || []);
      (g.x || []).forEach(function (it) { if (!map[it[0]]) map[it[0]] = items; });
    });
    return map;
  }

  function sizedUrl(url, width) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + width) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardVars(el) {
    var cs = window.getComputedStyle(el);
    return {
      size: parseFloat(cs.getPropertyValue('--vsw-card-size')) || 30,
      gap: parseFloat(cs.getPropertyValue('--vsw-card-gap')) || 6
    };
  }

  // Tekent de swatches; toont er zoveel als er passen (max CARD_MAX), de rest als "+N"
  function drawCard(el) {
    var items = el.__vswItems;
    var handle = el.getAttribute('data-vsw-handle');
    if (!items) return;

    var v = cardVars(el);
    var width = el.clientWidth || (el.parentElement && el.parentElement.clientWidth) || 0;
    var fit = width ? Math.max(2, Math.floor((width + v.gap) / (v.size + v.gap))) : CARD_MAX;
    var max = Math.min(CARD_MAX, fit);
    if (el.__vswMax === max && el.innerHTML) return;
    el.__vswMax = max;

    var overflow = items.length > max;
    var count = overflow ? max - 1 : items.length;
    var visible = items.slice(0, count);

    // Zorg dat de huidige kleur altijd zichtbaar is
    var currentIndex = -1;
    items.forEach(function (it, i) { if (it[0] === handle) currentIndex = i; });
    if (currentIndex >= count && count > 0) visible[count - 1] = items[currentIndex];

    var html = visible.map(function (it) {
      // it = [handle, name, imageUrl, available, url]
      var cls = 'vsw-card__swatch' + (it[0] === handle ? ' is-active' : '') + (it[3] ? '' : ' is-sold-out');
      return '<a href="' + esc(it[4]) + '" class="' + cls + '" title="' + esc(it[1]) + '" aria-label="' + esc(it[1]) + '" data-vsw-img="' + esc(it[2]) + '" data-instant>' +
        (it[2] ? '<img src="' + esc(sizedUrl(it[2], 96)) + '" alt="" width="48" height="48" loading="lazy" decoding="async">' : '') +
        '</a>';
    }).join('');

    if (overflow) {
      html += '<a class="vsw-card__more" href="' + esc(el.__vswLink || '#') + '" data-instant aria-label="+' + (items.length - count) + ' colors">+' + (items.length - count) + '</a>';
    }

    el.innerHTML = html;
  }

  function renderCard(el) {
    if (el.__vswDone) return;
    el.__vswDone = true;

    var handle = el.getAttribute('data-vsw-handle');
    var items = index && index[handle];
    if (!items || items.length < 2) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }

    var card = el.closest('product-item');
    var link = card && card.querySelector('a[href*="/products/"]');
    el.__vswItems = items;
    el.__vswLink = link ? link.getAttribute('href') : '#';
    el.hidden = false;
    drawCard(el);
    if (cardObserver) cardObserver.observe(el);
  }

  // Kaarten in verborgen tabs/sliders opnieuw passend maken zodra ze in beeld komen
  var cardObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) drawCard(entry.target); });
  }) : null;

  // Bij resize opnieuw bepalen hoeveel swatches er passen
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.vsw-card[data-vsw-handle]:not([hidden])').forEach(drawCard);
    }, 150);
  });

  var CFG = window.VSW_SETTINGS || {};
  var CARDS_ON = CFG.cards !== false;
  var CARD_MAX = parseInt(CFG.max, 10) || 5;

  function ensureCss() {
    if (!CFG.css || document.querySelector('link[href*="vovia-swatches.css"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = CFG.css;
    document.head.appendChild(l);
  }

  // Plaatst een lege .vsw-card in elke productkaart
  function addPlaceholders(scope) {
    var cards = (scope || document).querySelectorAll('product-item');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.__vswPlaced) return;
      card.__vswPlaced = true;
      if (card.closest('mini-cart, #mini-cart, .mini-cart, cart-drawer, .promotion-block, [data-vsw-off]')) return;
      var info = card.querySelector('.product-item__info');
      var link = card.querySelector('a[href*="/products/"]');
      if (!info || !link || info.querySelector('.vsw-card')) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var el = document.createElement('div');
      el.className = 'vsw-card';
      el.hidden = true;
      el.setAttribute('data-vsw-handle', decodeURIComponent(m[1]));
      // Zelfde plek als Swatch King: direct onder titel + prijs
      var meta = info.querySelector('.product-item-meta');
      if (meta && meta.parentNode === info) meta.insertAdjacentElement('afterend', el);
      else info.appendChild(el);
    });
  }

  function renderAll(scope) {
    if (!CARDS_ON) return;
    addPlaceholders(scope);
    var els = Array.prototype.filter.call((scope || document).querySelectorAll('.vsw-card[data-vsw-handle]'), function (el) { return !el.__vswDone; });
    if (!els.length) return;
    ensureCss();
    loadData().then(function (d) {
      if (!index) index = buildIndex(d);
      els.forEach(renderCard);
    });
  }

  // Hover-preview: kaartfoto tijdelijk vervangen door de foto van de gehoverde kleur
  function previewOn(a) {
    var card = a.closest('product-item');
    if (!card) return;
    var img = card.querySelector('.product-item__primary-image:not([hidden])') || card.querySelector('.product-item__primary-image');
    var src = a.getAttribute('data-vsw-img');
    if (!img || !src) return;
    if (!card.__vswOrig) {
      card.__vswOrig = { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
    }
    img.setAttribute('srcset', sizedUrl(src, 400) + ' 400w, ' + sizedUrl(src, 600) + ' 600w, ' + sizedUrl(src, 800) + ' 800w, ' + sizedUrl(src, 1000) + ' 1000w');
    img.setAttribute('src', sizedUrl(src, 600));
    card.classList.add('vsw-previewing');
  }

  function previewOff(card) {
    if (!card || !card.__vswOrig) return;
    var o = card.__vswOrig;
    if (o.srcset) o.img.setAttribute('srcset', o.srcset); else o.img.removeAttribute('srcset');
    if (o.src) o.img.setAttribute('src', o.src);
    card.classList.remove('vsw-previewing');
    card.__vswOrig = null;
  }

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('.vsw-card__swatch');
      if (a) previewOn(a);
    });
    document.addEventListener('mouseout', function (e) {
      var list = e.target.closest && e.target.closest('.vsw-card');
      if (!list) return;
      if (e.relatedTarget && list.contains(e.relatedTarget)) return;
      previewOff(list.closest('product-item'));
    });
  }

  function start() {
    renderAll(document);

    // Kaarten die later binnenkomen (recommendations, filters, infinite scroll, tabs)
    if (!CARDS_ON) return;
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.tagName === 'PRODUCT-ITEM' || (n.querySelector && n.querySelector('product-item')))) {
            pending = true;
            setTimeout(function () {
              pending = false;
              renderAll(document);
            }, 60);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
